import {PublishType} from '@wp-content-publisher/typings-lib/src/server/types/publish';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';


export const publishArticles = async (data: PublishType): Promise<PublishType> =>
    await apiRequest({
        url: `/articles/publish`,
        options: {method: 'POST'},
        data,
    });